import styled, { css } from 'styled-components';
import { themeGet, getTextColor } from '@magalu/stereo-ui-styles';
import Image from '../ResponsiveImage';
import Box from '../Box';
import Flex from '../Flex';
import Text from '../Text';
export const ImageContent = styled(Box)`
  border-radius: 50%;
  width: ${props => themeGet('sizes.hotLinks.width')(props)};
  height: ${props => themeGet('sizes.hotLinks.height')(props)};
  margin-bottom: 8px;
`;
export const Link = styled.a`
  display: block;
  text-decoration: none;
  width: 100%;
`;
export const LinkImage = styled(Image)``;
const columnStyle = css`
  flex-flow: wrap;
  background: ${props => themeGet('palette.background.lighter')(props)};
  padding: 0 8px;
  border-left: 4px solid ${({
  borderColor
}) => borderColor || 'transparent'};
  width: 100%;
  border-radius: 4px;
  box-shadow: ${props => themeGet('boxShadows.4')(props)};

  p {
    font-size: ${props => themeGet('fontSizes.2')(props)}px;
    color: ${props => getTextColor('scratched')(props)};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    text-align: left;
  }

  ${ImageContent} {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: ${props => themeGet('borders.0')(props)};
    margin: 4px 7px 4px 0;

    ${LinkImage} {
      width: 100%;
      border-radius: 50%;
    }
  }
`;
export const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;

  ${({
  directionType
}) => directionType === 'column' && columnStyle}
`;
export const TextComponent = styled(Text).attrs(() => ({
  color: 'base',
  fontSize: [0, 1, 2]
}))`
  text-align: center;
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;
`;